// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-guarantees {
  padding-bottom: 30px;
  max-width: 1088px;
  margin: 0 auto;
}
.page-guarantees .wrapper-breadcrumb {
  display: none;
  padding: 16px 16px 8px;
}
.page-guarantees .title-section {
  margin: 0;
  background: var(--sebrae-dark-green);
  padding: 16px;
  height: 55px;
  display: flex;
  align-items: center;
}
.page-guarantees .title-section h2 {
  font-size: 19px;
  font-weight: 700;
  color: var(--sebrae-white);
  margin: 0;
}
.page-guarantees .banner {
  position: relative;
}
.page-guarantees .banner img {
  width: 100%;
  object-fit: cover;
}
.page-guarantees .banner button {
  display: none;
  margin: 0;
  position: absolute;
  z-index: 1;
  right: 7%;
  bottom: 15%;
}
.page-guarantees .wrapper-container {
  padding-top: 16px;
}
.page-guarantees .box-content {
  position: relative;
  width: calc(100% - 8px);
  margin: 0 0 0 auto;
  background: var(--sebrae-white);
  color: var(--sebrae-dark-green);
  padding: 16px;
}
.page-guarantees .box-content.relative-box {
  border: 1px solid var(--sebrae-green-1);
}
.page-guarantees .box-content:before {
  content: "";
  position: absolute;
  z-index: -1;
  top: 8px;
  left: -8px;
  width: 100%;
  height: 100%;
  border: 1px solid var(--sebrae-dark-green);
}
.page-guarantees .box-content h5 {
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 8px;
  line-height: 1.5;
}
.page-guarantees .box-content strong {
  font-weight: 700;
}
.page-guarantees .box-content a {
  color: inherit;
  text-decoration: underline;
  font: inherit;
}
.page-guarantees .box-content p {
  font-size: 13px;
  font-weight: 400;
  margin-bottom: 15px;
  line-height: 1.2;
}
.page-guarantees .box-content ul {
  list-style: inherit;
  padding-left: 22px;
  font-size: 13px;
  font-weight: 400;
  line-height: 1.2;
  margin-bottom: 20px;
}
.page-guarantees .box-content .BaSe--grid {
  gap: 0;
}
.page-guarantees .box-content .box-content {
  padding: 0;
  width: 100%;
  background: none;
}
.page-guarantees .box-content .box-content .text-mobile {
  display: block;
}
.page-guarantees .box-content .box-content .text-desktop {
  display: none;
}
.page-guarantees .btn-green {
  width: 100%;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--sebrae-white);
  background: var(--sebrae-dark-green);
  padding: 12px;
  border-radius: 4px;
  font-weight: 700;
  font-size: 16px;
  margin-top: 32px;
}
.page-guarantees .btn-green.tablet {
  display: none;
  margin-top: 62px;
}
.page-guarantees .content-modal {
  color: var(--sebrae-dark-gray);
}
.page-guarantees .content-modal p {
  font-size: 13px;
  margin-bottom: 24px;
  line-height: 1.2;
}
.page-guarantees .content-modal label {
  font-size: 13px;
}
.page-guarantees .content-modal .BaSe--select,
.page-guarantees .content-modal .BaSe--input {
  margin-bottom: 16px;
}
.page-guarantees .content-modal .guarantees-form-area .BaSe--popover-card {
  max-width: 190px;
}
.page-guarantees .content-modal .tootip-title {
  display: flex;
}
.page-guarantees .content-modal .tootip-title small {
  color: var(--sebrae-dark-green);
}
.page-guarantees .content-modal .tootip-title span {
  color: var(--sebrae-gray) !important;
}
.page-guarantees .content-modal .btn-green {
  margin: 24px auto;
}
.page-guarantees .content-modal .fampe-range {
  margin-top: 24px;
}
.page-guarantees .content-modal .results {
  border-top: 1px solid var(--sebrae-light-gray4);
  padding-top: 24px;
}
.page-guarantees .content-modal .results .info-percent {
  width: 100%;
  padding: 16px;
  transition: all 255ms cubic-bezier(0.4, 0, 0.2, 1);
  background: var(--sebrae-white);
  color: var(--sebrae-green);
  border: 1px solid var(--sebrae-green);
  margin-bottom: 24px;
}
.page-guarantees .content-modal .results .info-percent h5 {
  color: inherit;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.2;
  margin-bottom: 18px;
}
.page-guarantees .content-modal .results .info-percent p {
  color: inherit;
  font-size: 13px;
  font-weight: 400;
  margin: 0;
  line-height: 1.2;
}
.page-guarantees .content-modal .results .info-percent a {
  color: inherit;
  text-decoration: underline;
  font: inherit;
}
.page-guarantees .content-modal .results .info-percent.green {
  color: var(--sebrae-green);
  border-color: var(--sebrae-green);
}
.page-guarantees .content-modal .results .info-percent.yellow {
  color: var(--sebrae-dark-yellow);
  border-color: var(--sebrae-dark-yellow);
}
.page-guarantees .content-modal .results .info-percent.blue {
  color: var(--sebrae-blue-6);
  border-color: var(--sebrae-blue-6);
}
.page-guarantees .content-modal .results .info-percent.red {
  color: var(--sebrae-red);
  border-color: var(--sebrae-red);
}
.page-guarantees .content-modal .results .group-input label {
  color: inherit !important;
  transition: all 255ms cubic-bezier(0.4, 0, 0.2, 1);
}
.page-guarantees .content-modal .results .group-input input {
  color: inherit;
  transition: all 255ms cubic-bezier(0.4, 0, 0.2, 1);
}
.page-guarantees .content-modal .results .group-input input::placeholder {
  color: inherit;
}
.page-guarantees .content-modal .results .group-input.green {
  color: var(--sebrae-green) !important;
  border-color: var(--sebrae-green);
}
.page-guarantees .content-modal .results .group-input.green input {
  color: var(--sebrae-green);
  border-color: var(--sebrae-green);
  background: var(--sebrae-light-green2);
}
.page-guarantees .content-modal .results .group-input.yellow {
  color: var(--sebrae-dark-yellow) !important;
  border-color: var(--sebrae-dark-yellow);
}
.page-guarantees .content-modal .results .group-input.yellow input {
  color: var(--sebrae-dark-yellow);
  border-color: var(--sebrae-yellow);
  background: var(--sebrae-light-yellow);
}
.page-guarantees .content-modal .results .group-input.blue {
  color: var(--sebrae-blue-6) !important;
}
.page-guarantees .content-modal .results .group-input.blue input {
  color: var(--sebrae-blue-6);
  border-color: var(--sebrae-light-blue2);
  background: var(--sebrae-light-blue3);
}
.page-guarantees .content-modal .results .group-input.gray-green {
  color: var(--sebrae-dark-green) !important;
}
.page-guarantees .content-modal .results .group-input.gray-green input {
  color: var(--sebrae-dark-green);
  border-color: var(--sebrae-light-green3);
  background: rgba(125, 162, 158, 0.3);
}
.page-guarantees .content-modal .results small {
  display: block;
  margin-bottom: 24px;
  color: var(--sebrae-dark-gray);
  font-size: 11px;
  font-style: italic;
  line-height: 1.1;
}
@media screen and (min-width: 360px) {
  .page-guarantees .content-modal .guarantees-form-area .BaSe--popover-card {
    max-width: 230px;
  }
}
@media screen and (min-width: 768px) {
  .page-guarantees .wrapper-breadcrumb {
    display: block;
  }
  .page-guarantees .title-section {
    background: none;
    padding: 24px 16px;
    height: auto;
  }
  .page-guarantees .title-section h2 {
    font-size: 19px;
    color: var(--sebrae-dark-green);
  }
  .page-guarantees .banner {
    padding: 0 16px;
    margin-bottom: 8px;
  }
  .page-guarantees .banner button {
    display: flex;
  }
  .page-guarantees .box-content {
    padding: 0;
    width: 100%;
    background: none;
    margin: 0;
  }
  .page-guarantees .box-content.relative-box {
    border: none;
  }
  .page-guarantees .box-content:before {
    display: none;
  }
  .page-guarantees .box-content .BaSe--grid {
    gap: 24px;
  }
  .page-guarantees .box-content .box-content {
    position: relative;
    width: calc(100% - 8px);
    height: 100%;
    margin: 0 0 0 auto;
    background: var(--sebrae-white);
    padding: 16px;
    border: 1px solid var(--sebrae-green-1);
  }
  .page-guarantees .box-content .box-content .text-mobile {
    display: none;
  }
  .page-guarantees .box-content .box-content .text-desktop {
    display: block;
  }
  .page-guarantees .box-content .box-content:before {
    content: "";
    position: absolute;
    z-index: -1;
    top: 8px;
    left: -8px;
    width: 100%;
    height: 100%;
    border: 1px solid var(--sebrae-dark-green);
    display: block;
  }
  .page-guarantees .btn-green {
    max-width: 239px;
    margin: 32px auto 0;
  }
  .page-guarantees .btn-green.mobile {
    display: none;
  }
  .page-guarantees .btn-green.tablet {
    display: flex;
  }
  .page-guarantees .content-modal p,
  .page-guarantees .content-modal label {
    font-size: 15px;
  }
  .page-guarantees .content-modal .btn-green {
    max-width: 100%;
  }
  .page-guarantees .content-modal .results .info-percent h5,
  .page-guarantees .content-modal .results .info-percent p {
    font-size: 15px;
  }
}
@media screen and (min-width: 1024px) {
  .page-guarantees .content-modal .BaSe--input {
    margin-bottom: 32px;
  }
  .page-guarantees .content-modal .BaSe--select {
    margin-bottom: 34px;
  }
  .page-guarantees .content-modal .guarantees-form-area {
    padding: 32px;
    border-radius: 8px;
    border: 1px solid var(--sebrae-light-gray4);
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.1);
  }
  .page-guarantees .content-modal .guarantees-form-area .BaSe--popover-card {
    max-width: max-content;
  }
  .page-guarantees .content-modal .guarantees-form-area .title-fampe {
    color: var(--sebrae-dark-green);
    font-size: 27px;
    font-style: normal;
    font-weight: 700;
    line-height: 1.2;
    margin-bottom: 16px;
  }
  .page-guarantees .content-modal .guarantees-form-area .description-fampe {
    font-size: 16px;
    font-weight: 400;
  }
  .page-guarantees .content-modal .guarantees-form-area .first-block label,
  .page-guarantees .content-modal .guarantees-form-area .group-input label {
    font-size: 13px !important;
  }
  .page-guarantees .content-modal .guarantees-form-area .first-block {
    gap: 32px;
    flex: 1 1;
    display: flex;
  }
  .page-guarantees .content-modal .guarantees-form-area .first-block .wrapper-select,
  .page-guarantees .content-modal .guarantees-form-area .first-block .group-input {
    flex: 1 1;
  }
  .page-guarantees .content-modal .guarantees-form-area .first-block .wrapper-select .BaSe--select-input,
  .page-guarantees .content-modal .guarantees-form-area .first-block .group-input .BaSe--select-input {
    color: var(--sebrae-black);
    border-color: var(--sebrae-light-gray5);
  }
  .page-guarantees .content-modal .guarantees-form-area .group-input {
    max-width: 388.5px;
  }
  .page-guarantees .content-modal .btn-area {
    width: 100%;
    display: flex;
    justify-content: end;
  }
  .page-guarantees .content-modal .btn-area .btn-green {
    margin: 24px 0;
    max-width: 199px;
  }
  .page-guarantees .content-modal .results {
    padding: 32px;
    border-radius: 8px;
    border: 1px solid var(--sebrae-light-gray4);
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.1);
  }
  .page-guarantees .content-modal .results__blocks {
    gap: 32px;
    display: flex;
  }
  .page-guarantees .content-modal .results__blocks .right-block-results,
  .page-guarantees .content-modal .results__blocks .left-block-results {
    flex: 1 1;
  }
  .page-guarantees .content-modal .results__blocks .right-block-results .BaSe--input,
  .page-guarantees .content-modal .results__blocks .left-block-results .BaSe--input {
    max-width: 100%;
  }
  .page-guarantees .content-modal .results__blocks .info-percent {
    margin-bottom: 0;
    border-radius: 4px;
    border: 1px solid var(--sebrae-light-blue2) !important;
  }
  .page-guarantees .content-modal .results__blocks .info-percent h5,
  .page-guarantees .content-modal .results__blocks .info-percent p {
    font-size: 13px;
  }
  .page-guarantees .content-modal .results__blocks .info-percent.yellow {
    border-radius: 0;
    border: 1px solid var(--sebrae-yellow) !important;
  }
  .page-guarantees .content-modal .results__blocks .info-percent.red {
    border-radius: 0;
    border: 1px solid var(--sebrae-red) !important;
  }
  .page-guarantees .content-modal .results__blocks .info-percent.green {
    border-radius: 0;
    border: 1px solid var(--sebrae-green) !important;
  }
  .page-guarantees .wrapper-breadcrumb {
    padding: 16px 30px 8px;
  }
  .page-guarantees .title-section {
    padding: 24px 30px;
  }
  .page-guarantees .banner {
    padding: 0 30px;
  }
  .page-guarantees .banner button {
    right: 154px;
    bottom: 105px;
  }
  .page-guarantees .box-content .box-content {
    width: calc(100% - 16px);
  }
  .page-guarantees .box-content .box-content:before {
    top: 16px;
    left: -16px;
  }
}
@media screen and (min-width: 1280px) {
  .page-guarantees .wrapper-breadcrumb {
    padding: 16px 40px 8px;
  }
  .page-guarantees .title-section {
    padding: 24px 40px;
  }
  .page-guarantees .banner {
    padding: 0 40px;
  }
  .page-guarantees .banner button {
    right: 154px;
    bottom: 105px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/guarantees/index.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;EACA,iBAAA;EACA,cAAA;AACF;AACE;EACE,aAAA;EACA,sBAAA;AACJ;AACE;EACE,SAAA;EACA,oCAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;AACJ;AACI;EAEI,eAAA;EACA,gBAAA;EAEF,0BAAA;EACA,SAAA;AADN;AAIE;EACE,kBAAA;AAFJ;AAGI;EACE,WAAA;EACA,iBAAA;AADN;AAGI;EACE,aAAA;EACA,SAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;AADN;AAIE;EACE,iBAAA;AAFJ;AAIE;EACE,kBAAA;EACA,uBAAA;EACA,kBAAA;EACA,+BAAA;EACA,+BAAA;EACA,aAAA;AAFJ;AAII;EACE,uCAAA;AAFN;AAKI;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,0CAAA;AAHN;AAMI;EAEI,eAAA;EACA,gBAAA;EAEF,kBAAA;EACA,gBAAA;AANN;AAQI;EACE,gBAAA;AANN;AAQI;EACE,cAAA;EACA,0BAAA;EACA,aAAA;AANN;AAQI;EAEI,eAAA;EACA,gBAAA;EAEF,mBAAA;EACA,gBAAA;AARN;AAUI;EACE,mBAAA;EACA,kBAAA;EAEE,eAAA;EACA,gBAAA;EAEF,gBAAA;EACA,mBAAA;AAVN;AAaI;EACE,MAAA;AAXN;AAcI;EACE,UAAA;EACA,WAAA;EACA,gBAAA;AAZN;AAcM;EACE,cAAA;AAZR;AAeM;EACE,aAAA;AAbR;AAiBE;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,0BAAA;EACA,oCAAA;EACA,aAAA;EACA,kBAAA;EAEE,gBAAA;EACA,eAAA;EAEF,gBAAA;AAjBJ;AAmBI;EACE,aAAA;EACA,gBAAA;AAjBN;AAoBE;EACE,8BAAA;AAlBJ;AAoBI;EACE,eAAA;EACA,mBAAA;EACA,gBAAA;AAlBN;AAoBI;EACE,eAAA;AAlBN;AAoBI;;EAEE,mBAAA;AAlBN;AAsBM;EACE,gBAAA;AApBR;AAwBI;EACE,aAAA;AAtBN;AAwBM;EACE,+BAAA;AAtBR;AAyBM;EACE,oCAAA;AAvBR;AA2BI;EACE,iBAAA;AAzBN;AA2BI;EACE,gBAAA;AAzBN;AA2BI;EACE,+CAAA;EACA,iBAAA;AAzBN;AA2BM;EACE,WAAA;EACA,aAAA;EACA,kDAAA;EACA,+BAAA;EACA,0BAAA;EACA,qCAAA;EACA,mBAAA;AAzBR;AA2BQ;EACE,cAAA;EAEE,eAAA;EACA,gBAAA;EAEF,gBAAA;EACA,mBAAA;AA3BV;AA6BQ;EACE,cAAA;EAEE,eAAA;EACA,gBAAA;EAEF,SAAA;EACA,gBAAA;AA7BV;AA+BQ;EACE,cAAA;EACA,0BAAA;EACA,aAAA;AA7BV;AAgCQ;EACE,0BAAA;EACA,iCAAA;AA9BV;AAgCQ;EACE,gCAAA;EACA,uCAAA;AA9BV;AAgCQ;EACE,2BAAA;EACA,kCAAA;AA9BV;AAgCQ;EACE,wBAAA;EACA,+BAAA;AA9BV;AAkCQ;EACE,yBAAA;EACA,kDAAA;AAhCV;AAkCQ;EACE,cAAA;EACA,kDAAA;AAhCV;AAkCU;EACE,cAAA;AAhCZ;AAmCQ;EACE,qCAAA;EACA,iCAAA;AAjCV;AAmCU;EACE,0BAAA;EACA,iCAAA;EACA,sCAAA;AAjCZ;AAoCQ;EACE,2CAAA;EACA,uCAAA;AAlCV;AAoCU;EACE,gCAAA;EACA,kCAAA;EACA,sCAAA;AAlCZ;AAqCQ;EACE,sCAAA;AAnCV;AAqCU;EACE,2BAAA;EACA,uCAAA;EACA,qCAAA;AAnCZ;AAsCQ;EACE,0CAAA;AApCV;AAsCU;EACE,+BAAA;EACA,wCAAA;EACA,oCAAA;AApCZ;AAwCM;EACE,cAAA;EACA,mBAAA;EACA,8BAAA;EAEE,eAAA;EACA,kBAAA;EAEF,gBAAA;AAxCR;AA6CE;EAGM;IACE,gBAAA;EA7CR;AACF;AAkDE;EACE;IACE,cAAA;EAhDJ;EAkDE;IACE,gBAAA;IACA,kBAAA;IACA,YAAA;EAhDJ;EAkDI;IACE,eAAA;IACA,+BAAA;EAhDN;EAmDE;IACE,eAAA;IACA,kBAAA;EAjDJ;EAmDI;IACE,aAAA;EAjDN;EAoDE;IACE,UAAA;IACA,WAAA;IACA,gBAAA;IACA,SAAA;EAlDJ;EAoDI;IACE,YAAA;EAlDN;EAqDI;IACE,aAAA;EAnDN;EAsDI;IACE,SAAA;EApDN;EAuDI;IACE,kBAAA;IACA,uBAAA;IACA,YAAA;IACA,kBAAA;IACA,+BAAA;IACA,aAAA;IACA,uCAAA;EArDN;EAuDM;IACE,aAAA;EArDR;EAwDM;IACE,cAAA;EAtDR;EAyDM;IACE,WAAA;IACA,kBAAA;IACA,WAAA;IACA,QAAA;IACA,UAAA;IACA,WAAA;IACA,YAAA;IACA,0CAAA;IACA,cAAA;EAvDR;EA2DE;IACE,gBAAA;IACA,mBAAA;EAzDJ;EA2DI;IACE,aAAA;EAzDN;EA2DI;IACE,aAAA;EAzDN;EA6DI;;IAEE,eAAA;EA3DN;EA6DI;IACE,eAAA;EA3DN;EA+DQ;;IAEE,eAAA;EA7DV;AACF;AAkEE;EAEI;IACE,mBAAA;EAjEN;EAmEI;IACE,mBAAA;EAjEN;EAoEI;IACE,aAAA;IACA,kBAAA;IACA,2CAAA;IACA,8CAAA;EAlEN;EAoEM;IACE,sBAAA;EAlER;EAqEM;IACE,+BAAA;IACA,eAAA;IACA,kBAAA;IACA,gBAAA;IACA,gBAAA;IACA,mBAAA;EAnER;EAsEM;IACE,eAAA;IACA,gBAAA;EApER;EAyEQ;;IACE,0BAAA;EAtEV;EA0EM;IACE,SAAA;IACA,SAAA;IACA,aAAA;EAxER;EA0EQ;;IAEE,SAAA;EAxEV;EA0EU;;IACE,0BAAA;IACA,uCAAA;EAvEZ;EA2EM;IACE,kBAAA;EAzER;EA6EI;IACE,WAAA;IACA,aAAA;IACA,oBAAA;EA3EN;EA6EM;IACE,cAAA;IACA,gBAAA;EA3ER;EA+EI;IACE,aAAA;IACA,kBAAA;IACA,2CAAA;IACA,8CAAA;EA7EN;EA+EM;IACE,SAAA;IACA,aAAA;EA7ER;EA+EQ;;IAEE,SAAA;EA7EV;EA+EU;;IACE,eAAA;EA5EZ;EAgFQ;IACE,gBAAA;IACA,kBAAA;IACA,sDAAA;EA9EV;EA+EU;;IAEE,eAAA;EA7EZ;EAgFU;IACE,gBAAA;IACA,iDAAA;EA9EZ;EAiFU;IACE,gBAAA;IACA,8CAAA;EA/EZ;EAkFU;IACE,gBAAA;IACA,gDAAA;EAhFZ;EAuFE;IACE,sBAAA;EArFJ;EAuFE;IACE,kBAAA;EArFJ;EAuFE;IACE,eAAA;EArFJ;EAuFI;IACE,YAAA;IACA,aAAA;EArFN;EAwFE;IACE,wBAAA;EAtFJ;EAwFI;IACE,SAAA;IACA,WAAA;EAtFN;AACF;AAyFE;EACE;IACE,sBAAA;EAvFJ;EAyFE;IACE,kBAAA;EAvFJ;EAyFE;IACE,eAAA;EAvFJ;EAyFI;IACE,YAAA;IACA,aAAA;EAvFN;AACF","sourcesContent":[".page-guarantees {\n  padding-bottom: 30px;\n  max-width: 1088px;\n  margin: 0 auto;\n\n  .wrapper-breadcrumb {\n    display: none;\n    padding: 16px 16px 8px;\n  }\n  .title-section {\n    margin: 0;\n    background: var(--sebrae-dark-green);\n    padding: 16px;\n    height: 55px;\n    display: flex;\n    align-items: center;\n\n    h2 {\n      font: {\n        size: 19px;\n        weight: 700;\n      }\n      color: var(--sebrae-white);\n      margin: 0;\n    }\n  }\n  .banner {\n    position: relative;\n    img {\n      width: 100%;\n      object-fit: cover;\n    }\n    button {\n      display: none;\n      margin: 0;\n      position: absolute;\n      z-index: 1;\n      right: 7%;\n      bottom: 15%;\n    }\n  }\n  .wrapper-container {\n    padding-top: 16px;\n  }\n  .box-content {\n    position: relative;\n    width: calc(100% - 8px);\n    margin: 0 0 0 auto;\n    background: var(--sebrae-white);\n    color: var(--sebrae-dark-green);\n    padding: 16px;\n\n    &.relative-box {\n      border: 1px solid var(--sebrae-green-1);\n    }\n\n    &:before {\n      content: \"\";\n      position: absolute;\n      z-index: -1;\n      top: 8px;\n      left: -8px;\n      width: 100%;\n      height: 100%;\n      border: 1px solid var(--sebrae-dark-green);\n    }\n\n    h5 {\n      font: {\n        size: 16px;\n        weight: 700;\n      }\n      margin-bottom: 8px;\n      line-height: 1.5;\n    }\n    strong {\n      font-weight: 700;\n    }\n    a {\n      color: inherit;\n      text-decoration: underline;\n      font: inherit;\n    }\n    p {\n      font: {\n        size: 13px;\n        weight: 400;\n      }\n      margin-bottom: 15px;\n      line-height: 1.2;\n    }\n    ul {\n      list-style: inherit;\n      padding-left: 22px;\n      font: {\n        size: 13px;\n        weight: 400;\n      }\n      line-height: 1.2;\n      margin-bottom: 20px;\n    }\n\n    .BaSe--grid {\n      gap: 0;\n    }\n\n    .box-content {\n      padding: 0;\n      width: 100%;\n      background: none;\n\n      .text-mobile {\n        display: block;\n      }\n\n      .text-desktop {\n        display: none;\n      }\n    }\n  }\n  .btn-green {\n    width: 100%;\n    height: 48px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: var(--sebrae-white);\n    background: var(--sebrae-dark-green);\n    padding: 12px;\n    border-radius: 4px;\n    font: {\n      weight: 700;\n      size: 16px;\n    }\n    margin-top: 32px;\n\n    &.tablet {\n      display: none;\n      margin-top: 62px;\n    }\n  }\n  .content-modal {\n    color: var(--sebrae-dark-gray);\n\n    p {\n      font-size: 13px;\n      margin-bottom: 24px;\n      line-height: 1.2;\n    }\n    label {\n      font-size: 13px;\n    }\n    .BaSe--select,\n    .BaSe--input {\n      margin-bottom: 16px;\n    }\n\n    .guarantees-form-area {\n      .BaSe--popover-card {\n        max-width: 190px;\n      }\n    }\n\n    .tootip-title {\n      display: flex;\n\n      small {\n        color: var(--sebrae-dark-green);\n      }\n\n      span {\n        color: var(--sebrae-gray) !important;\n      }\n    }\n\n    .btn-green {\n      margin: 24px auto;\n    }\n    .fampe-range {\n      margin-top: 24px;\n    }\n    .results {\n      border-top: 1px solid var(--sebrae-light-gray4);\n      padding-top: 24px;\n\n      .info-percent {\n        width: 100%;\n        padding: 16px;\n        transition: all 255ms cubic-bezier(0.4, 0, 0.2, 1);\n        background: var(--sebrae-white);\n        color: var(--sebrae-green);\n        border: 1px solid var(--sebrae-green);\n        margin-bottom: 24px;\n\n        h5 {\n          color: inherit;\n          font: {\n            size: 13px;\n            weight: 700;\n          }\n          line-height: 1.2;\n          margin-bottom: 18px;\n        }\n        p {\n          color: inherit;\n          font: {\n            size: 13px;\n            weight: 400;\n          }\n          margin: 0;\n          line-height: 1.2;\n        }\n        a {\n          color: inherit;\n          text-decoration: underline;\n          font: inherit;\n        }\n\n        &.green {\n          color: var(--sebrae-green);\n          border-color: var(--sebrae-green);\n        }\n        &.yellow {\n          color: var(--sebrae-dark-yellow);\n          border-color: var(--sebrae-dark-yellow);\n        }\n        &.blue {\n          color: var(--sebrae-blue-6);\n          border-color: var(--sebrae-blue-6);\n        }\n        &.red {\n          color: var(--sebrae-red);\n          border-color: var(--sebrae-red);\n        }\n      }\n      .group-input {\n        label {\n          color: inherit !important;\n          transition: all 255ms cubic-bezier(0.4, 0, 0.2, 1);\n        }\n        input {\n          color: inherit;\n          transition: all 255ms cubic-bezier(0.4, 0, 0.2, 1);\n\n          &::placeholder {\n            color: inherit;\n          }\n        }\n        &.green {\n          color: var(--sebrae-green) !important;\n          border-color: var(--sebrae-green);\n\n          input {\n            color: var(--sebrae-green);\n            border-color: var(--sebrae-green);\n            background: var(--sebrae-light-green2);\n          }\n        }\n        &.yellow {\n          color: var(--sebrae-dark-yellow) !important;\n          border-color: var(--sebrae-dark-yellow);\n\n          input {\n            color: var(--sebrae-dark-yellow);\n            border-color: var(--sebrae-yellow);\n            background: var(--sebrae-light-yellow);\n          }\n        }\n        &.blue {\n          color: var(--sebrae-blue-6) !important;\n\n          input {\n            color: var(--sebrae-blue-6);\n            border-color: var(--sebrae-light-blue2);\n            background: var(--sebrae-light-blue3);\n          }\n        }\n        &.gray-green {\n          color: var(--sebrae-dark-green) !important;\n\n          input {\n            color: var(--sebrae-dark-green);\n            border-color: var(--sebrae-light-green3);\n            background: rgba(125, 162, 158, 0.3);\n          }\n        }\n      }\n      small {\n        display: block;\n        margin-bottom: 24px;\n        color: var(--sebrae-dark-gray);\n        font: {\n          size: 11px;\n          style: italic;\n        }\n        line-height: 1.1;\n      }\n    }\n  }\n\n  @media screen and (min-width: 360px) {\n    .content-modal {\n      .guarantees-form-area {\n        .BaSe--popover-card {\n          max-width: 230px;\n        }\n      }\n    }\n  }\n\n  @media screen and (min-width: 768px) {\n    .wrapper-breadcrumb {\n      display: block;\n    }\n    .title-section {\n      background: none;\n      padding: 24px 16px;\n      height: auto;\n\n      h2 {\n        font-size: 19px;\n        color: var(--sebrae-dark-green);\n      }\n    }\n    .banner {\n      padding: 0 16px;\n      margin-bottom: 8px;\n\n      button {\n        display: flex;\n      }\n    }\n    .box-content {\n      padding: 0;\n      width: 100%;\n      background: none;\n      margin: 0;\n\n      &.relative-box {\n        border: none;\n      }\n\n      &:before {\n        display: none;\n      }\n\n      .BaSe--grid {\n        gap: 24px;\n      }\n\n      .box-content {\n        position: relative;\n        width: calc(100% - 8px);\n        height: 100%;\n        margin: 0 0 0 auto;\n        background: var(--sebrae-white);\n        padding: 16px;\n        border: 1px solid var(--sebrae-green-1);\n\n        .text-mobile {\n          display: none;\n        }\n\n        .text-desktop {\n          display: block;\n        }\n\n        &:before {\n          content: \"\";\n          position: absolute;\n          z-index: -1;\n          top: 8px;\n          left: -8px;\n          width: 100%;\n          height: 100%;\n          border: 1px solid var(--sebrae-dark-green);\n          display: block;\n        }\n      }\n    }\n    .btn-green {\n      max-width: 239px;\n      margin: 32px auto 0;\n\n      &.mobile {\n        display: none;\n      }\n      &.tablet {\n        display: flex;\n      }\n    }\n    .content-modal {\n      p,\n      label {\n        font-size: 15px;\n      }\n      .btn-green {\n        max-width: 100%;\n      }\n      .results {\n        .info-percent {\n          h5,\n          p {\n            font-size: 15px;\n          }\n        }\n      }\n    }\n  }\n  @media screen and (min-width: 1024px) {\n    .content-modal {\n      .BaSe--input {\n        margin-bottom: 32px;\n      }\n      .BaSe--select {\n        margin-bottom: 34px;\n      }\n\n      .guarantees-form-area {\n        padding: 32px;\n        border-radius: 8px;\n        border: 1px solid var(--sebrae-light-gray4);\n        box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.1);\n\n        .BaSe--popover-card {\n          max-width: max-content;\n        }\n\n        .title-fampe {\n          color: var(--sebrae-dark-green);\n          font-size: 27px;\n          font-style: normal;\n          font-weight: 700;\n          line-height: 1.2;\n          margin-bottom: 16px;\n        }\n\n        .description-fampe {\n          font-size: 16px;\n          font-weight: 400;\n        }\n\n        .first-block,\n        .group-input {\n          label {\n            font-size: 13px !important;\n          }\n        }\n\n        .first-block {\n          gap: 32px;\n          flex: 1;\n          display: flex;\n\n          .wrapper-select,\n          .group-input {\n            flex: 1;\n\n            .BaSe--select-input {\n              color: var(--sebrae-black);\n              border-color: var(--sebrae-light-gray5);\n            }\n          }\n        }\n        .group-input {\n          max-width: 388.5px;\n        }\n      }\n\n      .btn-area {\n        width: 100%;\n        display: flex;\n        justify-content: end;\n\n        .btn-green {\n          margin: 24px 0;\n          max-width: 199px;\n        }\n      }\n\n      .results {\n        padding: 32px;\n        border-radius: 8px;\n        border: 1px solid var(--sebrae-light-gray4);\n        box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.1);\n\n        &__blocks {\n          gap: 32px;\n          display: flex;\n\n          .right-block-results,\n          .left-block-results {\n            flex: 1;\n\n            .BaSe--input {\n              max-width: 100%;\n            }\n          }\n\n          .info-percent {\n            margin-bottom: 0;\n            border-radius: 4px;\n            border: 1px solid var(--sebrae-light-blue2) !important;\n            h5,\n            p {\n              font-size: 13px;\n            }\n\n            &.yellow {\n              border-radius: 0;\n              border: 1px solid var(--sebrae-yellow) !important;\n            }\n\n            &.red {\n              border-radius: 0;\n              border: 1px solid var(--sebrae-red) !important;\n            }\n\n            &.green {\n              border-radius: 0;\n              border: 1px solid var(--sebrae-green) !important;\n            }\n          }\n        }\n      }\n    }\n\n    .wrapper-breadcrumb {\n      padding: 16px 30px 8px;\n    }\n    .title-section {\n      padding: 24px 30px;\n    }\n    .banner {\n      padding: 0 30px;\n\n      button {\n        right: 154px;\n        bottom: 105px;\n      }\n    }\n    .box-content .box-content {\n      width: calc(100% - 16px);\n\n      &:before {\n        top: 16px;\n        left: -16px;\n      }\n    }\n  }\n  @media screen and (min-width: 1280px) {\n    .wrapper-breadcrumb {\n      padding: 16px 40px 8px;\n    }\n    .title-section {\n      padding: 24px 40px;\n    }\n    .banner {\n      padding: 0 40px;\n\n      button {\n        right: 154px;\n        bottom: 105px;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
